import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Table, Select, Input, Button, Tooltip, Modal } from "antd";
import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import { req_page_usm_space_deparrtment } from "../../api";

import SpaceDepartmentManagerModal from "./space-department-manager-modal";
class SpaceDepartment extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    courseRooms: [],
    storageGoods: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    buildingName: "NONE",
    departmentCode: "NONE",

    isShowConfigModal: false,
    isShowAddModal: false,
    isShowEditModal: false,
    isShowCourseModal: false,
    isShowStorageModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_page_items = async (current) => {
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_usm_space_deparrtment(
      userLevel,
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );

    // console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination, loading: false });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination, loading: false });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "部門全名",
        dataIndex: "DepartmentTwName",
        width: 50,
        fixed: "left",
      },
      {
        title: "部門簡稱",
        dataIndex: "ShortDepartmentTwName",
        width: 30,
        fixed: "left",
      },
      {
        title: "綜管人姓名",
        dataIndex: "AgentTwName",
        width: 25,
      },
      {
        title: "",
        width: 20,
        fixed: "right",
        render: (item) => {
          const { userLevel } = this.state;
          return (
            <>
              {userLevel === "PERSIONAL" ? (
                ""
              ) : (
                <>
                  <button
                    className="btn btn-outline-dark btn-sm"
                    style={{ width: "82px" }}
                    onClick={() => this.handle_show_ui_modal("EDIT", item)}
                  >
                    <i className="fa fa-cog"></i> 修改
                  </button>
                </>
              )}
            </>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_show_ui_modal = (type, item) => {
    //console.log(item);
    const { SpaceCode } = item;
    switch (type) {
      case "ADD":
        this.setState({ isShowAddModal: true });
        break;
      case "EDIT":
        this.setState({ isShowEditModal: true, item });
        break;
      case "DELETE":
        const { Uid } = item;
        Modal.confirm({
          title: `您確定刪除此空間資訊`,
          onOk: () => {
            this.api_delete_item(Uid);
          },
        });
        break;
      case "EXPORT":
        this.api_downloadfile_items();
        break;
      case "CONFIG":
        this.setState({ isShowConfigModal: true });
        break;
      case "COURSEROOMSLIST":
        this.api_list_course_rooms(SpaceCode);
        break;
      case "STORAGEGOODSLIST":
        this.api_list_storage_goods(SpaceCode);
        break;
      default:
    }
    this.setState({ item: item });
  };

  handleSelectedChange(value, field) {
    if (field === "BuildingName") {
      this.setState({ buildingName: value });
    }
  }

  //////////////////////////////////////////////////////////
  render() {
    const {
      loading,
      item,
      items,
      pagination,
      searchField,
      searchValue,
      isShowEditModal,
    } = this.state;
    const title = (
      <>
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="ShortDepartmentTwName">部門名稱</Select.Option>
          <Select.Option value="AgentCode">綜管人職號</Select.Option>
          <Select.Option value="AgentTwName">綜管人姓名</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search" style={{ paddingRight: "4px" }}></i> 查詢
        </Button>
        <p></p>
      </>
    );
    return (
      <>
        {title}
        <Card>
          <Table
            bordered
            scroll={{ x: 800, y: 380 }}
            loading={loading}
            rowKey="Uid"
            columns={this.columns}
            dataSource={items}
            onChange={this.handle_table_change}
            pagination={{
              ...pagination,
              responsive: true,
              showQuickJumper: true,
              showSizeChanger: true,
              pageSizeOptions: [5, 10, 20, 50, 100],
              // onChange: this.api_page_applycase,
              onShowSizeChange: this.handle_page_size_change,
            }}
          />
          <Modal
            destroyOnClose={true}
            visible={isShowEditModal}
            okText="關閉"
            onOk={() => {
              this.setState({ isShowEditModal: false });
              this.handle_data_refresh();
            }}
            onCancel={() => {
              this.setState({ isShowEditModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <SpaceDepartmentManagerModal department={item} />
          </Modal>
        </Card>
      </>
    );
  }
}
export default connect((state) => ({ user: state.user }), {})(SpaceDepartment);
